import { render, staticRenderFns } from "./LektionsinhaltModal.vue?vue&type=template&id=10654f6b&"
import script from "./LektionsinhaltModal.vue?vue&type=script&lang=js&"
export * from "./LektionsinhaltModal.vue?vue&type=script&lang=js&"
import style0 from "./LektionsinhaltModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports